import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { getRetailerByIdApi } from "api";
import { Select } from 'antd';
import debounce from 'lodash.debounce';
import { FaSearch } from "react-icons/fa";
import ClipLoader from "react-spinners/ClipLoader";
import "./style.scss";
import { useCircularContext } from 'contexts';

export const SearchByMultipleRetailer = ({
  isLoading,
  func,
  onSearch,
  queryParams,
  placeholder = 'Search By Multiple Retailers',
  
}) => {
  const [options, setOptions] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [selectedValue, setSelectedValue] = useState([])

  const {
      setFilter,
      retailerId
    } = useCircularContext();

  useEffect(() => {
    const fetchRetailers = async () => {
      if (queryParams.retailerId) {
        let retailerIds = queryParams.retailerId.split(',');
        setFilter({retailerId: queryParams.retailerId});
        let options = []

        for (let id of retailerIds) {
          let res = await getRetailerByIdApi(id);
          if (res.success) {
            options.push({label:res.results.name, value: res.results.id});

          }
        }
        setSelectedValue(options);
      }
    };
    
    fetchRetailers();
  }, [queryParams.retailerId]);

  // Debounced fetch
  const debouncedFetch = useMemo(() => 
    debounce(async (search) => {
      setIsFetching(true);
      try {
        const data = await func(search);
        setOptions(data.results || []);
      } finally {
        setIsFetching(false);
      }
    }, 500)
  , [func]);

  const handleAutoComplete = useCallback((search) => {
    if (search) {
      debouncedFetch(search);
    } else {
      setOptions([]);
    }
  }, [debouncedFetch]);


  const handleSearch = () => {
    onSearch();
  }
  
  const handleOnClick = () => {
    setOptions([]);
  }

  // Clean up debounce on unmount
  React.useEffect(() => {
    return () => debouncedFetch.cancel();
  }, [debouncedFetch]);

  return (
    <div className="d-flex search-multiple-retailer">
      <Select
        style={{ width: '90%', maxWidth: '220px' }}
        value={selectedValue}
        onSelect={value => {
          const v = options.find(option => option.id === value);
          const newValue = [...selectedValue, {label:v.name, value: v.id}];
          const newIds = [...(Array.isArray(retailerId) ? retailerId : retailerId ? retailerId.split(',') : []), v.id];
          setSelectedValue(newValue);
          setFilter({retailerId: newIds.join(',')});
        }}
        mode="multiple"
        onSearch={handleAutoComplete}
        onClick={handleOnClick}
        onDeselect={value => {
          const newValues = selectedValue.filter(option => option.value != value);
          const newIds = Array.isArray(retailerId) ? retailerId : retailerId ? retailerId.split(',').filter(id => id != value) : "";
          setSelectedValue(newValues);
          setFilter({retailerId: newIds.join(',')});
        }}
        placeholder={placeholder}
        notFoundContent={isLoading || isFetching ? <ClipLoader size={32} color="#006280" /> : null}
        options={options}
        fieldNames={{ label: 'name', value: 'id' }}
        optionFilterProp="name"
      />
      <FaSearch className={"search-button"} onClick={() => handleSearch(selectedValue)} />
    </div>
  );
};
